/**
 * Slick.js
 * http://kenwheeler.github.io/slick/
 */
export default class Slider {

    constructor() {
        this.self = $('.homepage-slider');
        this.slideTriggers = $(".slider-nav-item");
        this.slideTriggers.on('click', (e) => this.goToSlide(e));
        this.createSlickSlider();
    }

    createSlickSlider() {
        let self = this;
        if(this.self.length) {
            this.self.slick({
                infinite: true,
                speed: 400,
                fade: true,
                slidesToShow: 1,
                adaptiveHeight: false,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                prevArrow: '<button type="button" class="slick-arrow slick-prev"><img src="/img/Icons/arrow-right.svg" alt="Slider Button"></button>',
                nextArrow: '<button type="button" class="slick-arrow slick-next"><img src="/img/Icons/arrow-right.svg" alt="Slider Button"></button>',
                dots: false,
            });
            const nav = document.querySelector('.slick-list');
            const controlsNav = document.createElement('div');
            controlsNav.classList.add('controls');
            nav.appendChild(controlsNav);
            controlsNav.appendChild(document.querySelector('.slick-arrow.slick-prev'));
            controlsNav.appendChild(document.querySelector('.slick-arrow.slick-next'));

            const firstSlide = this.self.find('.slick-slide[data-slick-index="0"]');
            const firstBg = firstSlide.find('.slider-image').css('background-image');
            $('.hero-background .video-container > div').css('background-image', firstBg);

            this.self.on('afterChange', (event, slick, currentSlide) => {
                const currentSlideEl = this.self.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
                const bg = currentSlideEl.find('.slider-image').css('background-image');
                $('.hero-background .video-container > div').css('background-image', bg);
            });
        }
    }

    goToSlide(e) {
        e.preventDefault();
        let $trigger = $(e.currentTarget);
        let slideID = $trigger.attr('data-slide-id');
        this.slideTriggers.removeClass('active');
        $trigger.addClass('active');
        this.self.slick('slickGoTo', slideID);

    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Slider.js